import React from 'react';
import password from '../styles/passwordchange.module.css';
import logo from '../assets/img/user.png';
import usePasswordChange from '../hooks/usePasswordChange';

const PasswordChange = () => {
  const {
    newPassword,
    setNewPassword,
    handlePasswordChange
  } = usePasswordChange();

  return (
    <div className={password.main}>
      <div className={password.primero}>
        <h2>Bienvenidos a +Aliadas</h2>
        <img src={logo} alt="" />
        <h2>Cambio de contraseña</h2>
        <h6>
          Introduce tu nueva contraseña
        </h6>
      </div>

      <div className={password.segundo}>
        <input
          type="password"
          placeholder="Nueva contraseña"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />

        <button 
          onClick={handlePasswordChange}
          disabled={!newPassword || newPassword.trim() === ""}
        >
          Cambiar Contraseña
        </button>
      </div>
    </div>
  );
};

export default PasswordChange;